/**
 * ESIGN §101(c) consumer disclosure copy (CON-7 / CON-10).
 *
 * Status: INTERIM — pending attorney review (Sprint 63 AWS/legal checklist).
 * When counsel signs off, replace DISCLOSURE_BODY / CONSENT_LABEL only.
 * Clients accept terms + electronic consent with one checkbox.
 */
export const ESIGN_DISCLOSURE_STATUS = 'interim-pending-attorney-review' as const;

export const ESIGN_DISCLOSURE_TITLE = 'Electronic Signature Disclosure';

export const ESIGN_DISCLOSURE_BODY = [
  'You are consenting to use electronic records and signatures for this transaction under the federal ESIGN Act and applicable state law (including UETA where adopted, and New York ESRA where applicable).',
  'You may request a paper copy of this contract, withdraw consent to electronic delivery, or use an alternate signing method by contacting the company before you sign.',
  'Hardware and software requirements: a modern web browser and internet access. Your electronic signature will be applied to this contract only.',
  'Your consent is recorded with this signature event and retained with the executed contract records.',
].join(' ');

export const ESIGN_DISCLOSURE_CONSENT_LABEL =
  'I agree to the terms of this contract and consent to receive and sign electronically.';

export const CHANGE_ORDER_CONSENT_LABEL =
  'I agree to the terms of this change order and consent to receive and sign electronically.';
